import React from "react";

const LoadingSmall = ({className}) => {
  return (
    <div className="flex justify-center items-center w-auto">
      <div
        className={`w-12 h-12 ${className} border-4 border-green-500 border-t-transparent rounded-full animate-spin`}
        role="status"
      >
        <span className="sr-only">Đang tải...</span>
      </div>
    </div>
  );
};

export default LoadingSmall;
